import React, { useState } from 'react';
import HeaderText from '../../Common/HeaderText';
import LoginFormRow from './LoginFormRow';
import NewEmailForm from './NewEmailForm';
import NewPasswordForm from './NewPasswordForm';
import { Banner, useAuth, useT } from '@repo/common';
import EmailVerifyCodeModal from './EmailVerifyCodeModal';
import { sendVerificationCode } from '../../../../api/user/user.api';

const LoginForm = ({
  openForm,
  onOpenFormChange,
  onEmailSuccess,
  onPasswordSuccess,
}) => {
  const t = useT();
  const { user } = useAuth();
  const emailVerified = user?.emailVerified;
  const [showVerifyModal, setShowVerifyModal] = useState(false);

  return (
    <div className='flex flex-col max-w-[568px] w-full items-start pb-[60px]'>
      <HeaderText label={t('Login', '로그인')} />

      <div className='flex flex-col items-start tabletH:gap-4 w-full'>
        <div
          className={`
            w-full
            ${
              openForm === 'password' || openForm === 'verify'
                ? 'pointer-events-none [&_*]:text-text-disable'
                : ''
            }
          `}
        >
          <LoginFormRow
            label='Email'
            value={user?.email}
            showEmailForm={openForm === 'email'}
            onClickChange={() =>
              onOpenFormChange(openForm === 'email' ? null : 'email')
            }
          />
        </div>
        {user?.email && !emailVerified && (
          <div
            className={`mt-3 tabletH:mt-0 mb-2 tabletH:mb-0
              ${
                openForm === 'password'
                  ? 'pointer-events-none opacity-60 w-full'
                  : 'w-full'
              }
            `}
          >
            <Banner
              type='warning'
              size='s'
              label={t(
                'Email not verified. Verify your email to receive application updates.',
                '이메일이 인증되지 않았습니다. 지원 현황 알림을 받으려면 이메일을 인증해 주세요.',
              )}
              buttonLabel={t('Verify email', '이메일 인증')}
              hideClose
              onButtonClick={() => {
                onOpenFormChange(openForm === 'verify' ? null : 'verify');
                sendVerificationCode(user.email);
                setShowVerifyModal(true);
              }}
              className='py-2 tabletH:p-4'
              gap='gap-1.5 tabletH:gap-2'
            />
          </div>
        )}
        {openForm === 'email' && (
          <NewEmailForm
            onClose={() => onOpenFormChange(null)}
            onSuccess={onEmailSuccess}
          />
        )}
        {showVerifyModal && (
          <EmailVerifyCodeModal
            email={user?.email}
            onClose={() => {
              setShowVerifyModal(false);
              onOpenFormChange(null);
            }}
          />
        )}

        <div
          className={`
            w-full mt-5 tabletH:mt-0
            ${
              openForm === 'email' || openForm === 'verify'
                ? 'pointer-events-none [&_*]:text-text-disable'
                : ''
            }
          `}
        >
          <LoginFormRow
            label='Password'
            value={user?.hasPw ? '•••••••••••' : ''}
            showPasswordForm={openForm === 'password'}
            onClickChange={() =>
              onOpenFormChange(openForm === 'password' ? null : 'password')
            }
          />
        </div>
        {openForm === 'password' && (
          <NewPasswordForm
            onClose={() => onOpenFormChange(null)}
            onSuccess={onPasswordSuccess}
          />
        )}
      </div>
    </div>
  );
};

export default LoginForm;
